import { getTiersForUser, type Country } from '@skin-seoul/service';

/** Sign-in banner message suffixes for guest users, keyed by cart milestone state */
export const SIGN_IN_BANNER_MESSAGE = {
  /** Cart below free shipping threshold */
  belowFreeShipping: ' for free shipping!',
  /** Cart at or above free shipping, below 10% OFF */
  reachedFreeShipping: ' to earn points on your purchase!',
  /** Cart at or above 10% OFF milestone */
  reachedTenPercentOff: ' to also get free shipping on this order!',
} as const;

/**
 * Returns the sign-in banner message suffix based on cart total and guest BMSM tiers.
 * Used when the user is not authenticated to show contextual copy.
 */
export function getSignInBannerSuffix(cartTotalPrice: number, country: Country): string {
  const tiers = getTiersForUser({ country, isAuthenticated: false, isFirstOrder: false });
  if (tiers.length === 0) {
    return SIGN_IN_BANNER_MESSAGE.belowFreeShipping;
  }
  const [firstTier, secondTier] = tiers;
  if (cartTotalPrice < firstTier.threshold) {
    return SIGN_IN_BANNER_MESSAGE.belowFreeShipping;
  }
  if (secondTier && cartTotalPrice < secondTier.threshold) {
    return SIGN_IN_BANNER_MESSAGE.reachedFreeShipping;
  }
  return SIGN_IN_BANNER_MESSAGE.reachedTenPercentOff;
}
